export const maqueta = {
    text1: "Foram feitos",
    text2: "Check-ins",
    text3: "Folhas de papel economizadas 😊",
    text4: "A cada 100 check-ins plantamos uma árvore com",
    text5: "ONE TREE PLANTED",
    text6: "Notificações",
    text7: "Você não tem notificações",
    text8: "Ver todas",
    text9: "Bem-vindo",
    text10: "Empresa",
    text11: "Todas as acomodações",
    text12: "Perfil",
    text13: "Sair",
    text14: "Desculpe, ocorreu um erro ao sair",
    text15: "O pagamento da sua assinatura foi recusado",
    text16: "Para continuar usando o WACheckin, você precisa concluir seu pagamento",
    text17: "Informações do check-in",
    text18: "Dados do check-in",
    text19: "Data da solicitação:",
    text20: " às",
    text21: "Dados coletados durante o check-in do hóspede",
    text22: "Nome",
    text23: "Sobrenome",
    text24: "Telefone",
    text25: "Data da estadia",
    text26: "Tipo de documento",
    text27: "Passaporte",
    text28: "Documento nacional de identidade",
    text29: "Número do documento",
    text30: "Informações adicionais",
    text31: "Validade do documento",
    text32: "Nacionalidade",
    text33: "Data de nascimento",
    text34: "Gênero",
    text35: "Feminino",
    text36: "Masculino",
    text37: "Fechar",
    text38: "Check-ins",
    text39: "Solicitações de serviço",
    text40: "Acomodações",
    text41: "Vendas cruzadas",
    text42: "Integrações",
    text43: "Faturamento",

    // Corrections
    p1: "Reservas",

    // Plan validation corrections
    p2: `Faça upgrade do seu plano para realizar check-ins`,
    p3: `Desculpe, você não tem nenhuma assinatura ativa nem créditos para sua acomodação no momento.`,
    p4: `Fazer upgrade do plano`,

    p5: `Os check-ins não estão disponíveis nesta acomodação.`,
    p6: `Para mais informações, entre em contato com o proprietário.`,

    p7: `Conta não verificada`,
    p8: `Verifique sua caixa de entrada e confirme sua conta. Não recebeu o e-mail?`,
    p9: `Reenviar`,
    p10: `Enviando e-mail, aguarde...`,
    p11: `Minha assinatura`,

    p12: `Idioma e região`,
    p13: `Escolha um idioma e uma região`,
    p14: `Aqui você pode ver todos os check-ins concluídos.`,
    p15: `Agende seus check-ins com antecedência e envie-os aos seus hóspedes.`,
    p16: `Aqui você encontrará as solicitações de serviço dos seus hóspedes, como aluguéis, passeios e muito mais.`,
    p17: `WhatsApp em massa`,
    p18: `Conecte sua conta do WhatsApp Business à nossa plataforma e ative o envio em massa de mensagens personalizadas aos seus hóspedes de forma rápida e fácil, direto do seu número oficial.`,
    p19: `Este recurso ainda está em desenvolvimento.`,
    p20: `Informações do check-in`,

    p21: `Informações do check-in`,
    p22: `Check-ins associados`,
    p23: `Nenhum check-in associado.`,
    p24: `Mais informações:`,
    p25: `Qual acomodação você gostaria de gerenciar?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
